import React from "react";
import { Link, useParams } from "react-router-dom";
import { PageShell } from "@/components/layout/PageShell";
import { Seo } from "@/components/seo/Seo";

export function PaySuccess() {
  const { orderId } = useParams<{ orderId: string }>();
  return (
    <PageShell
      title="Your gift is recorded."
      subtitle="A receipt is on its way to your inbox."
      stewardship="Give · success"
    >
      <Seo title="Thank you" description="" path={`/give/${orderId ?? ""}/success`} noindex />
      <div className="max-w-xl">
        <p className="font-serif text-base text-ink-2 leading-relaxed mb-6">
          The receipt includes a link where you can change your recognition preference any time
          &mdash; the Foundation never overrides that choice.
        </p>
        <p className="font-mono text-xs text-ink-3 mb-8">Donation #{orderId}</p>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/foundation/contribute"
            className="bg-ink text-paper px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-ink-2"
          >
            Back to Contribute
          </Link>
          <Link
            to="/foundation"
            className="border border-ink text-ink px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-paper-2"
          >
            About the Foundation
          </Link>
        </div>
      </div>
    </PageShell>
  );
}
